const debounce = (callback, wait) => {
	let timeoutId = null;
	return (...args) => {
		window.clearTimeout(timeoutId);
		timeoutId = window.setTimeout(() => {
		callback.apply(null, args);
		}, wait);
	};
}

function equalizeSlideHeights(flickityInstance) {
	if (!flickityInstance) return;

	const slides = flickityInstance.element.querySelectorAll('.flickity-slider > *');
	let maxHeight = 0;

	slides.forEach(slide => {
		slide.style.height = '';
		const slideHeight = slide.offsetHeight;
		maxHeight = Math.max(maxHeight, slideHeight);
	});

	slides.forEach(slide => {
		slide.style.height = `${maxHeight}px`;
	});

	flickityInstance.resize();
}